import React, { Suspense } from 'react';
import { RelayErrorBoundary } from '../error-boundary/RelayErrorBoundary';
import { componentWithFG } from '@atlaskit/platform-feature-flags-react';

const RelayBoundaryAndSuspenseWithFallback = ({
	children,
	fallback = null,
	errorFallback = null,
}: {
	children: React.ReactNode;
	errorFallback?: React.ReactNode;
	fallback?: React.ReactNode;
}) => (
	<RelayErrorBoundary fallback={errorFallback}>
		<Suspense fallback={fallback}>{children}</Suspense>
	</RelayErrorBoundary>
);

const RelayErrorBoundaryWithFallback = ({
	children,
	errorFallback = null,
}: {
	children: React.ReactNode;
	errorFallback?: React.ReactNode;
	fallback?: React.ReactNode;
}) => <RelayErrorBoundary fallback={errorFallback}>{children}</RelayErrorBoundary>;

export const RelaySuspensefulBoundary: React.FC<
	{
		children: React.ReactNode;
		errorFallback?: React.ReactNode;
		fallback?: React.ReactNode;
	} & {
		children: React.ReactNode;
		errorFallback?: React.ReactNode;
		fallback?: React.ReactNode;
	}
> = componentWithFG(
	'forge-ui-add-suspense-and-relay-boundary',
	RelayBoundaryAndSuspenseWithFallback,
	RelayErrorBoundaryWithFallback,
);
